import { render, staticRenderFns } from "./recommendJob.vue?vue&type=template&id=1e516407&scoped=true"
import script from "./recommendJob.vue?vue&type=script&lang=js"
export * from "./recommendJob.vue?vue&type=script&lang=js"
import style0 from "./recommendJob.vue?vue&type=style&index=0&id=1e516407&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e516407",
  null
  
)

export default component.exports